import React, { useState, useEffect } from 'react';
function round(number, decimals = 0) {
  return Math.round((Math.pow(10, decimals) * parseFloat(number ?? 0))) / Math.pow(10, decimals)
}
function custom_number_format(number) {
  let SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"]
  var tier = Math.log10(Math.abs(number)) / 3 | 0;
  if (tier == 0) return number;
  if (tier == 1) return number_format(number);
  var suffix = SI_SYMBOL[tier];
  var scale = Math.pow(10, tier * 3);
  var scaled = number / scale;
  return scaled.toFixed(2) + suffix;
}

const number_format_ = (x) => {
  try {
    let [integerPart, decimalPart] = x.toString().split("."); // Split integer and decimal parts
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas to integer part only
    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart; // Rejoin parts correctly
  } catch (e) {
    return x;
  }
};
const StockPrice = (params) => {


  let decimals = params.decimals ?? 0
  let custom_format = params.custom_format ?? false
  let number_format = params.number_format ?? false
  
  let item = params.item
  let prop = params.prop
  let append = params.append
  let prepend = params.prepend
  let price = round(item[prop], decimals).toString()
  let isNegative = item[prop] < 0;

  if (custom_format) {
    price = custom_number_format(price)
  }
  if (number_format) {
    price = number_format_(price)
  }

  const [prevPrice, setPrevPrice] = useState(price);
  const [newPrice, setNewPrice] = useState(price);

  useEffect(() => {
    setPrevPrice(newPrice);
    setNewPrice(price);
  }, [price]);


  const renderPrice = () => {
    let color_class = '';

    return newPrice.split('').map((digit, index) => {
      if (prevPrice[index] !== digit) {
        if (isNegative) {
          color_class = newPrice < prevPrice ? 'text-green-500' : 'text-red-500';

        } else {
          color_class = newPrice > prevPrice ? 'text-green-500' : 'text-red-500';

        }
      }

      return (
        <span key={index} className={`${color_class}`}>
          {digit}

        </span>
      );
    });
  };
  return (
    <div>
      {prepend && <span>{prepend}</span>}

      {renderPrice() || "-"}
      {append && <span>{append}</span>}
    </div>
  );
};

export default StockPrice;